import PropTypes from 'prop-types';

export default {
  tenant: PropTypes.shape({
    id: PropTypes.number,
    displayName: PropTypes.string,
  }),
  user: {
    picture: PropTypes.string,
    name: PropTypes.string,
    subscribedTenants: PropTypes.array,
  },
  status: {
    id: PropTypes.number,
    tenant: PropTypes.string,
    name: PropTypes.string,
    statusOrder: PropTypes.number,
    endingStatus: PropTypes.boolean,
    iconColor: PropTypes.string,
    icon: PropTypes.string,
    archived: PropTypes.boolean,
  },
  statusShape: PropTypes.shape({
    id: PropTypes.number,
    tenant: PropTypes.string,
    name: PropTypes.string,
    statusOrder: PropTypes.number,
    endingStatus: PropTypes.boolean,
    iconColor: PropTypes.string,
    icon: PropTypes.string,
    archived: PropTypes.boolean,
  }),
  dashboardShape: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    directLinkName: PropTypes.string,
    name: PropTypes.string,
    organizationExposed: PropTypes.boolean,
    dashboardData: PropTypes.shape({
      endDate: PropTypes.date,
      includeArchived: PropTypes.boolean,
      includeComplete: PropTypes.boolean,
      searchText: PropTypes.string,
      startDate: PropTypes.date,
      statusIds: PropTypes.arrayOf(PropTypes.number),
      tagConditions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
    }),
  }),
  dashboard: {
    id: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
    description: PropTypes.string,
    directLinkName: PropTypes.string,
    name: PropTypes.string,
    organizationExposed: PropTypes.boolean,
    dashboardData: PropTypes.shape({
      endDate: PropTypes.date,
      includeArchived: PropTypes.boolean,
      includeComplete: PropTypes.boolean,
      searchText: PropTypes.string,
      startDate: PropTypes.date,
      statusIds: PropTypes.arrayOf(PropTypes.number),
      tagConditions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
    }),
  },
  searchEvents: {
    endDate: PropTypes.date,
    includeArchived: PropTypes.boolean,
    includeComplete: PropTypes.boolean,
    searchText: PropTypes.string,
    startDate: PropTypes.date,
    statusIds: PropTypes.arrayOf(PropTypes.number),
    tagConditions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  },
  pagination: {
    page: PropTypes.number,
    size: PropTypes.number,
    search: PropTypes.string,
    sort: PropTypes.arrayOf(PropTypes.string),
  },
};
